export default "__VITE_ASSET__Bv98SfHS__"